export default function isStorybook() {
  return !!document.querySelector('#signal-in-storybook');
}